




import OptionalFeed from '@/component/view/OptionalFeed.vue';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { TopicsService } from '@/kuroco_api';

@Component<MyPageLiked>({
  components: {
    OptionalFeed,
  },
})
export default class MyPageLiked extends Vue {
  // FIELDS
  title = 'いいね！した投稿';
  query: TopicsService.getTopicsServiceRcmsApi1FeedsRequest = {
    myFavoriteList: 1,
  };
}
